<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
  <div #buttonTreeView>
    <mat-button-toggle-group [formControl]="viewGroup">
      <mat-button-toggle value="listView">
        <fa-icon icon="list"></fa-icon>
      </mat-button-toggle>
      <mat-button-toggle value="treeView">
        <fa-icon icon="sitemap"></fa-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div #buttonAddAccount>
    <button mat-raised-button color="primary" [routerLink]="['gl-accounts/create']" *mifosxHasPermission="'CREATE_GLACCOUNT'">
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      Add Account
    </button>
  </div>
</div>

<!-- List View -->

<div class="container" [hidden]="viewGroup.value !== 'listView'">

  <div #filter fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>

  <div #accountsTable class="mat-elevation-z8">

    <table mat-table [dataSource]="tableDataSource" matSort>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Account </th>
        <td mat-cell *matCellDef="let glAccount"> {{ glAccount.name }} </td>
      </ng-container>

      <ng-container matColumnDef="glCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> GL Code </th>
        <td mat-cell *matCellDef="let glAccount"> {{ glAccount.glCode }} </td>
      </ng-container>

      <ng-container matColumnDef="glAccountType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let glAccount"> {{ glAccount.type.value }} </td>
      </ng-container>

      <ng-container matColumnDef="disabled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Disabled </th>
        <td mat-cell *matCellDef="let glAccount">
          <div [className]="glAccount.disabled === true ? 'disabled' : 'enabled'">
            <fa-icon matTooltip="{{ glAccount.disabled === true ? 'Disabled' : 'Enabled' }}" matTooltipPosition="right" icon="circle" size="lg"></fa-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="manualEntriesAllowed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Manual Entries Allowed </th>
        <td mat-cell *matCellDef="let glAccount">
          <fa-icon *ngIf="glAccount.manualEntriesAllowed" class="manual-entries-allowed" matTooltip="Allowed" matTooltipPosition="right" icon="check-circle" size="lg"></fa-icon>
          <fa-icon *ngIf="!glAccount.manualEntriesAllowed" class="manual-entries-not-allowed" matTooltip="Not Allowed" matTooltipPosition="right" icon="times-circle" size="lg"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="usedAs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Used as </th>
        <td mat-cell *matCellDef="let glAccount"> {{ glAccount.usage.value }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['gl-accounts/view', row.id]" class="select-row"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>

  </div>

</div>


<!-- Tree View -->

<div class="container" [hidden]="viewGroup.value !== 'treeView'">

  <div class="m-b-20"  fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
    <button mat-raised-button (click)="nestedTreeControl.expandAll()">  <!-- Bug(angular-material): https://github.com/angular/material2/issues/12170 -->
      Expand All
    </button>
    <button mat-raised-button (click)="nestedTreeControl.collapseAll()">
      Collapse All
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="4%" fxLayout.lt-md="column">

    <div fxFlex="48%" *ngIf="glAccount">

      <mat-card>

        <mat-card-content>

          <div fxLayout="row wrap" class="content">

            <div fxFlex="50%" class="header">
              Account Name
            </div>

            <div fxFlex="50%">
              {{ glAccount.name }}
            </div>

            <div fxFlex="50%" class="header">
              GL Code
            </div>

            <div fxFlex="50%">
              {{ glAccount.glCode }}
            </div>

            <div fxFlex="50%" class="header">
              Account Type
            </div>

            <div fxFlex="50%">
              {{ glAccount.type }}
            </div>

            <div fxFlex="50%" class="header">
              Account Usage
            </div>

            <div fxFlex="50%">
              {{ glAccount.usage }}
            </div>

            <div fxFlex="50%" class="header">
              Manual Entries Allowed
            </div>

            <div fxFlex="50%">
              {{ glAccount.manualEntriesAllowed }}
            </div>

            <div fxFlex="50%" class="header">
              Description
            </div>

            <div fxFlex="50%">
              {{ glAccount.description }}
            </div>

          </div>

        </mat-card-content>

      </mat-card>

    </div>

    <div class="mat-elevation-z8" fxFlex>

      <mat-tree [dataSource]="nestedTreeDataSource" [treeControl]="nestedTreeControl" class="gl-account-tree">

        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <li class="mat-tree-node">
            <button mat-icon-button disabled></button>
            <span (click)="viewGLAccountNode(node)">
              <span *ngIf="node.glCode">{{ '(' + node.glCode + ')' }}</span>&nbsp;&nbsp;
              {{ node.name }}
            </span>
          </li>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
          <li>
            <div class="mat-tree-node">
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <fa-icon class="mat-icon-rtl-mirror" icon="{{ nestedTreeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right' }}"></fa-icon>
              </button>
              <span (click)="viewGLAccountNode(node)">
                <span *ngIf="node.glCode">{{ '(' + node.glCode + ')' }}</span>&nbsp;&nbsp;
                {{ node.name }}
              </span>
            </div>
            <ul [class.gl-account-tree-invisible]="!nestedTreeControl.isExpanded(node)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>

      </mat-tree>

    </div>

  </div>

</div>

<ng-template #templateButtonTreeView let-popover="popover">
  <h2>Tree View</h2>
  <p class="mw300">There is an alternative way to view your accounts - using the Tree View.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();previousStep();">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover( templateButtonAddAccount, buttonAddAccount, 'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateButtonAddAccount let-popover="popover">
  <h2>Add Account</h2>
  <p class="mw300">This option allows you to create new GL accounts.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateButtonTreeView, buttonTreeView , 'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateFilter, filter, 'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateFilter let-popover="popover">
  <h4>Search bar to filter GL accounts.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover( templateButtonAddAccount, buttonAddAccount, 'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateAccountsTable, accountsTable, 'top', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateAccountsTable let-popover="popover">
  <h4 class="mw300">List of chart of all the accounts being used by your organization.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateFilter, filter, 'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();nextStep()">Next</button>
  </div>
</ng-template>
